module.exports = __webpack_public_path__ + "img/thumbnails-18-new-year-countdown.21253294.png";